import { render } from "./LoginRegisterModel.vue?vue&type=template&id=90c64e60"
import script from "./LoginRegisterModel.vue?vue&type=script&lang=js"
export * from "./LoginRegisterModel.vue?vue&type=script&lang=js"

import "./LoginRegisterModel.vue?vue&type=style&index=0&id=90c64e60&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__